import CitySEOHead from "@/components/feature/CitySEOHead";
import DaltonHeroSection from "./components/HeroSection";
import DaltonStickyNav from "./components/StickyNav";
import DaltonProcessingTimeSection from "./components/ProcessingTimeSection";
import DaltonServicesSection from "./components/ServicesSection";
import DaltonLocalAreaSection from "./components/LocalAreaSection";
import DaltonTestimonialsSection from "./components/TestimonialsSection";
import DaltonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DaltonComparisonSection from "./components/ComparisonSection";
import DaltonMistakesSection from "./components/MistakesSection";
import DaltonHowItWorksSection from "./components/HowItWorksSection";
import DaltonFAQSection, { faqs } from "./components/FAQSection";
import DaltonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DaltonFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DaltonPage() {
  return (
    <>
      <CitySEOHead
        city="Dalton"
        state="Georgia"
        stateAbbr="GA"
        route="/dalton"
        title="Emergency Passport Dalton, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Dalton, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Whitfield County and northwest Georgia travelers. Get your emergency passport fast!"
        geoPlacename="Dalton, Georgia"
        geoPosition="34.7698;-84.9702"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Dalton passport, same day passport Dalton, fast passport Georgia, Whitfield County passport"
      />
      <div className="font-sans">
        <DaltonHeroSection />
        <DaltonStickyNav />
        <DaltonProcessingTimeSection />
        <DaltonServicesSection />
        <DaltonLocalAreaSection />
        <DaltonTestimonialsSection />
        <DaltonAcceptanceFacilitiesSection />
        <DaltonComparisonSection />
        <DaltonMistakesSection />
        <DaltonHowItWorksSection />
        <DaltonFAQSection />
        <DaltonHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/dalton" state="GA" />
        <DaltonFinalCTA />
      </div>
    </>
  );
}